"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PostSsrRuntimeContent = exports.PostSsrRuntime = exports.PostSSRRuntimeContext = void 0;
var tslib_1 = require("tslib");
var lodash_1 = require("lodash");
var react_1 = tslib_1.__importDefault(require("react"));
exports.PostSSRRuntimeContext = react_1.default.createContext({
    setContent: lodash_1.noop,
    getContent: (0, lodash_1.constant)([]),
});
var PostSsrRuntime = /** @class */ (function (_super) {
    tslib_1.__extends(PostSsrRuntime, _super);
    function PostSsrRuntime() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.content = [];
        _this.halted = false;
        _this.setContent = function (content) {
            if (!_this.halted) {
                _this.content = _this.content.concat(content);
            }
        };
        _this.getContent = function () {
            return _this.content;
        };
        return _this;
    }
    PostSsrRuntime.prototype.componentDidMount = function () {
        this.halted = true;
        this.content = [];
    };
    PostSsrRuntime.prototype.render = function () {
        return (react_1.default.createElement(exports.PostSSRRuntimeContext.Provider, { value: { setContent: this.setContent, getContent: this.getContent } }, this.props.children));
    };
    return PostSsrRuntime;
}(react_1.default.Component));
exports.PostSsrRuntime = PostSsrRuntime;
var PostSsrRuntimeContent = function (_a) {
    var children = _a.children;
    return (react_1.default.createElement(exports.PostSSRRuntimeContext.Consumer, null, function (_a) {
        var setContent = _a.setContent;
        setContent(children);
        return null;
    }));
};
exports.PostSsrRuntimeContent = PostSsrRuntimeContent;
//# sourceMappingURL=post-ssr-runtime.js.map